import {INIT_UNLOCK_STATE, UNLOCK_STEP} from '~/common/fabric/constants';

export const createInitialState = ({inEditMode, activeStep, filteredEventSteps}) => {
  const allStepsArr = [];

  Object.values(filteredEventSteps).forEach((step) => allStepsArr.push(step.name));

  const stepArr =
    filteredEventSteps &&
    Object.values(filteredEventSteps)
      .filter((step) => typeof step.id === 'number' && step.id > 0)
      .filter((step) => !activeStep || step.id <= filteredEventSteps[activeStep]?.id)
      .map((step) => step.name);

  return inEditMode ? allStepsArr : stepArr;
};

export const unlockedStepsReducer = (state = ['customize'], action = {}) => {
  switch (action.type) {
    case INIT_UNLOCK_STATE: {
      const {inEditMode, activeStep, filteredEventSteps} = action.payload;

      const newSteps = createInitialState({inEditMode, activeStep, filteredEventSteps});
      return Array.from(new Set([...state, ...newSteps]));
    }
    case UNLOCK_STEP: {
      const newSteps = action.payload || [];
      return Array.from(new Set([...state, ...newSteps]));
    }
    default:
      return state;
  }
};
